var _defs, _g, _path, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _g12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClassBlueDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1640,
    viewBox: "0 0 1230 693",
    height: 924,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M877 347h352.113v345H877Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1175 99h9v8.43h-9Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1194 99h9v8.43h-9Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1214 99h9v8.43h-9Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 684h9v8H4Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 569.387h9V578H4Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 684h9v8h-9Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 684h10v8H43Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 684h9v8h-9Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83 684h9v8h-9Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102 684h10v8h-10Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122 684h9v8h-9Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M1222.422 368.715c32.402 21.183 52.05 61.762 61.234 101.574 9.188 39.559 7.91 78.352 1.79 115.867-5.872 37.774-16.333 74.266-37.508 105.914-21.18 31.645-52.563 58.446-89.817 72.48-37.508 14.294-80.371 15.825-117.113 2.298-36.488-13.782-66.852-42.621-94.664-74.266-27.813-31.394-53.328-65.336-63.278-104.383-10.207-39.047-5.105-83.199 12.758-121.226 17.86-38.028 48.477-69.93 84.711-89.325 35.977-19.398 77.82-26.289 121.2-28.84 43.374-2.808 88.28-1.019 120.687 19.907Zm0 0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M1077.008 7.438a4.026 4.026 0 0 1 8.05 0 4.026 4.026 0 0 1-8.05 0Zm0 0",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M1096.066 26.57c0-2.222 1.82-4.023 4.063-4.023 2.246 0 4.062 1.8 4.062 4.023s-1.816 4.024-4.062 4.024c-2.242 0-4.063-1.801-4.063-4.024Zm0-19.132c0-2.223 1.82-4.024 4.063-4.024 2.246 0 4.062 1.8 4.062 4.024 0 2.222-1.816 4.023-4.062 4.023-2.242 0-4.063-1.8-4.063-4.024Zm19.137 19.207c0-2.22 1.8-4.024 4.024-4.024a4.025 4.025 0 0 1 0 8.05 4.026 4.026 0 0 1-4.024-4.026Zm0-19.133c0-2.219 1.8-4.024 4.024-4.024a4.025 4.025 0 0 1 0 8.051 4.026 4.026 0 0 1-4.024-4.027Zm0 38.343a4.023 4.023 0 1 1 8.047 0 4.023 4.023 0 1 1-8.047 0Zm19.969-19.21a4.025 4.025 0 1 1 8.051.004 4.025 4.025 0 0 1-8.051-.004Zm0-19.133a4.025 4.025 0 1 1 8.051.004 4.025 4.025 0 0 1-8.051-.004Zm0 38.343a4.026 4.026 0 0 1 8.05 0 4.026 4.026 0 0 1-8.05 0Zm0 19.133a4.026 4.026 0 0 1 8.05 0 4.026 4.026 0 0 1-8.05 0Zm19.973-38.265a4.023 4.023 0 1 1 8.046 0 4.023 4.023 0 1 1-8.046 0Zm0-19.133a4.023 4.023 0 1 1 8.046 0 4.023 4.023 0 1 1-8.046 0Zm0 38.34a4.023 4.023 0 1 1 8.046 0c0 2.222-1.8 4.027-4.023 4.027a4.026 4.026 0 0 1-4.023-4.027Zm0 19.133c0-2.22 1.8-4.024 4.023-4.024a4.025 4.025 0 0 1 0 8.05 4.026 4.026 0 0 1-4.023-4.026Zm0 19.132c0-2.218 1.8-4.023 4.023-4.023a4.025 4.025 0 0 1 0 8.05 4.026 4.026 0 0 1-4.023-4.027Zm19.895-57.55c0-2.22 1.815-4.024 4.062-4.024 2.242 0 4.062 1.805 4.062 4.024 0 2.222-1.82 4.027-4.062 4.027-2.247 0-4.063-1.805-4.063-4.027Zm0-19.133c0-2.219 1.815-4.024 4.062-4.024 2.242 0 4.062 1.805 4.062 4.024 0 2.222-1.82 4.027-4.062 4.027-2.247 0-4.063-1.805-4.063-4.027Zm0 38.343c0-2.222 1.815-4.023 4.062-4.023 2.242 0 4.062 1.8 4.062 4.023s-1.82 4.024-4.062 4.024c-2.247 0-4.063-1.8-4.063-4.024Zm0 19.133c0-2.222 1.815-4.023 4.062-4.023 2.242 0 4.062 1.8 4.062 4.023s-1.82 4.024-4.062 4.024c-2.247 0-4.063-1.801-4.063-4.024Zm0 19.172a4.06 4.06 0 0 1 4.062-4.062 4.062 4.062 0 1 1 0 8.125 4.062 4.062 0 0 1-4.063-4.063Zm0 0",
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M1175.04 103.332c0-2.223 1.815-4.027 4.062-4.027 2.242 0 4.062 1.804 4.062 4.027 0 2.219-1.82 4.023-4.062 4.023-2.247 0-4.063-1.804-4.063-4.023Zm0 0",
    fillRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M1194.172 26.723a4.026 4.026 0 0 1 8.05 0 4.026 4.026 0 0 1-8.05 0Zm0-19.133a4.026 4.026 0 0 1 8.05 0 4.026 4.026 0 0 1-8.05 0Zm0 38.34a4.026 4.026 0 1 1 8.052.005 4.026 4.026 0 0 1-8.052-.005Zm0 19.133a4.025 4.025 0 1 1 8.051.004 4.025 4.025 0 0 1-8.051-.005Zm0 19.132a4.025 4.025 0 1 1 8.051.004 4.025 4.025 0 0 1-8.051-.004Zm0 0",
    fillRule: "evenodd"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M1194.172 103.406a4.026 4.026 0 0 1 8.05 0 4.026 4.026 0 0 1-8.05 0Zm0 0",
    fillRule: "evenodd"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M1214.066 26.645a4.025 4.025 0 1 1 8.051.004 4.025 4.025 0 0 1-8.05-.004Zm0 19.21a4.026 4.026 0 0 1 8.051 0 4.026 4.026 0 0 1-8.05 0Zm0 19.133a4.026 4.026 0 0 1 8.051 0 4.026 4.026 0 0 1-8.05 0Zm0 19.172c0-2.246 1.805-4.062 4.028-4.062 2.222 0 4.023 1.816 4.023 4.062 0 2.242-1.8 4.063-4.023 4.063s-4.028-1.82-4.028-4.063Zm0 0",
    fillRule: "evenodd"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M1214.066 103.332a4.026 4.026 0 1 1 4.027 4.023 4.029 4.029 0 0 1-4.027-4.023Zm0 0",
    fillRule: "evenodd"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M4.117 650.246a4.026 4.026 0 1 1 8.052.005 4.026 4.026 0 0 1-8.052-.005Zm0-19.133a4.026 4.026 0 0 1 8.051 0 4.026 4.026 0 0 1-8.05 0Zm0 38.344a4.026 4.026 0 0 1 8.051 0 4.026 4.026 0 0 1-8.05 0Zm0 0",
    fillRule: "evenodd"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M4.117 688.59a4.026 4.026 0 0 1 8.051 0 4.026 4.026 0 0 1-8.05 0Zm0 0",
    fillRule: "evenodd"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M4.117 611.906a4.026 4.026 0 0 1 8.051 0 4.026 4.026 0 0 1-8.05 0Zm0-19.211a4.026 4.026 0 1 1 8.052.006 4.026 4.026 0 0 1-8.052-.006Zm0 0",
    fillRule: "evenodd"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M4.117 573.488a4.026 4.026 0 0 1 8.051 0 4.026 4.026 0 0 1-8.05 0Zm0 0",
    fillRule: "evenodd"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M24.09 650.324a4.023 4.023 0 1 1 8.047 0 4.023 4.023 0 1 1-8.047 0Zm0-19.133a4.023 4.023 0 1 1 8.047 0 4.023 4.023 0 1 1-8.047 0Zm0 38.34a4.023 4.023 0 1 1 8.047 0 4.023 4.023 0 1 1-8.047 0Zm0 0",
    fillRule: "evenodd"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M24.09 688.664a4.023 4.023 0 1 1 8.047 0 4.023 4.023 0 1 1-8.047 0Zm0 0",
    fillRule: "evenodd"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M24.09 611.98a4.023 4.023 0 1 1 8.047 0 4.023 4.023 0 1 1-8.047 0Zm0-19.207a4.023 4.023 0 1 1 8.047 0 4.023 4.023 0 1 1-8.047 0Zm19.894 57.473c0-2.223 1.817-4.023 4.063-4.023 2.242 0 4.062 1.8 4.062 4.023s-1.82 4.027-4.062 4.027c-2.246 0-4.063-1.804-4.063-4.027Zm0-19.133c0-2.222 1.817-4.023 4.063-4.023 2.242 0 4.062 1.8 4.062 4.023s-1.82 4.024-4.062 4.024c-2.246 0-4.063-1.801-4.063-4.024Zm0 38.344c0-2.223 1.817-4.023 4.063-4.023 2.242 0 4.062 1.8 4.062 4.023s-1.82 4.023-4.062 4.023c-2.246 0-4.063-1.8-4.063-4.023Zm0 0",
    fillRule: "evenodd"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M43.984 688.59c0-2.223 1.817-4.024 4.063-4.024 2.242 0 4.062 1.801 4.062 4.024 0 2.222-1.82 4.023-4.062 4.023-2.246 0-4.063-1.8-4.063-4.023Zm0 0",
    fillRule: "evenodd"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M43.984 611.906c0-2.222 1.817-4.023 4.063-4.023 2.242 0 4.062 1.8 4.062 4.023s-1.82 4.024-4.062 4.024c-2.246 0-4.063-1.801-4.063-4.024Zm19.137 38.418a4.023 4.023 0 1 1 8.047 0 4.023 4.023 0 1 1-8.047 0Zm0-19.133a4.023 4.023 0 1 1 8.047 0 4.023 4.023 0 1 1-8.047 0Zm0 38.34a4.023 4.023 0 1 1 8.047 0 4.023 4.023 0 1 1-8.047 0Zm0 0",
    fillRule: "evenodd"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M63.121 688.664a4.023 4.023 0 1 1 8.047 0 4.023 4.023 0 1 1-8.047 0Zm0 0",
    fillRule: "evenodd"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M83.016 650.246a4.023 4.023 0 1 1 8.046 0c0 2.223-1.8 4.027-4.023 4.027a4.026 4.026 0 0 1-4.023-4.027Zm0 19.211a4.023 4.023 0 1 1 8.046 0 4.023 4.023 0 1 1-8.046 0Zm0 0",
    fillRule: "evenodd"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M83.016 688.59a4.023 4.023 0 1 1 8.046 0 4.023 4.023 0 1 1-8.046 0Zm0 0",
    fillRule: "evenodd"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M102.91 669.457c0-2.223 1.817-4.023 4.063-4.023 2.242 0 4.062 1.8 4.062 4.023s-1.82 4.023-4.062 4.023c-2.246 0-4.063-1.8-4.063-4.023Zm0 0",
    fillRule: "evenodd"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M102.91 688.59c0-2.223 1.817-4.024 4.063-4.024 2.242 0 4.062 1.801 4.062 4.024 0 2.222-1.82 4.023-4.062 4.023-2.246 0-4.063-1.8-4.063-4.023Zm0 0",
    fillRule: "evenodd"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1939B7",
    d: "M122.879 688.512a4.025 4.025 0 1 1 8.05.003 4.025 4.025 0 0 1-8.05-.003Zm0 0",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassBlueDots);
export default __webpack_public_path__ + "static/media/class-blue-dots.a664736ed683c1b8cb11a3971f791c49.svg";
export { ForwardRef as ReactComponent };